import React from 'react'
import misaareunion from "../images/misaa re-union Annual re-union 2024.jpg";
import misaaannualgettogether from "../images/misaa re-union Annual get-together.jpg";


function Slidermisaa() {
  return (
    <div>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={misaaannualgettogether} className="d-block w-100" alt="misaaannualgettogether"/>
    </div>
    <div className="carousel-item">
      <img src={misaareunion} className="d-block w-100" alt="misaareunion2024_berhampore"/>
    </div>
  
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slidermisaa